import React, { useState } from 'react'

import { Cell } from '../../table/elements'
import { Status, StatusDropdown, StatusDropdownItem } from './elements'
import { statusMap } from '../../../constants/status'
import Icon from 'app/components/commons/Icon'

export const TripStatus = ({ status, disableChange, onChange, isLoading }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false)

  const statusItemOnClick = (newStatus) => {
    setDropdownOpen(false)
    onChange(newStatus)
  }

  const isDropdownDisabled = disableChange || status?.name === 'Cancelled'

  return (
    <Cell
      onMouseEnter={() => !isDropdownDisabled && setDropdownOpen(true)}
      onMouseLeave={() => !isDropdownDisabled && setDropdownOpen(false)}
      style={{ minWidth: '165px' }}
    >
      <Status $background={`${status?.color}`}>
        {isLoading ? (
          'Loading...'
        ) : (
          <span style={{ padding: '10px' }}>{status?.name}</span>
        )}
        {dropdownOpen && !isDropdownDisabled && (
          <StatusDropdown onClick={(e) => e.stopPropagation()}>
            {Object.entries(statusMap).map((el) => (
              <StatusDropdownItem
                onClick={() => statusItemOnClick(el[0])}
                $active={el[1].name === status?.name}
                key={el}
              >
                {el[1].name}
              </StatusDropdownItem>
            ))}
          </StatusDropdown>
        )}
        {!isDropdownDisabled && (
          <Icon $noMargin>{dropdownOpen ? 'expand_less' : 'expand_more'}</Icon>
        )}
      </Status>
    </Cell>
  )
}
